/*
 * ywv-search-best.js - POD Hub
 * Swaps the predictive-search PRODUCT tiles for the best sellers of the keyword
 * being typed ("rain" -> rainbow best sellers). Word suggestions and the
 * "Search for ..." button are left exactly as Shopify rendered them.
 * Data: assets/ywv-search-best-{a..z,0}.json, written nightly by
 * pod-hub scripts/search-bestsellers-sync.ts. Any miss or error leaves
 * Shopify's own tiles in place, silently.
 */
(function () {
  'use strict';
  try {
    var cfg = document.getElementById('ywv-search-best-config');
    if (!cfg || !window.fetch || !window.MutationObserver) return;
    var urls = JSON.parse(cfg.getAttribute('data-urls') || '{}');
  } catch (e) {
    return;
  }

  var MAX_TILES = 6;
  var STOP = toSet('the and for with you your our are from this that all its his her him she they them was were has have had not but can any one two out off get got who how why what when where which into onto over under upon about just only very more most much many some such than then too also own same new yes vibe vibes vibing ywv yeswevibe size title select free sale best');
  var TYPE = toSet('sneaker sneakers boot boots hightop hightops high top tops lowtop lowtops low slipon slipons slip shoe shoes women womens woman men mens man unisex kid kids casual chunky blanket blankets hooded hoodie hat hats cap caps sock socks tapestry tapestries bag bags tote totes legging leggings dress bandana bandanas flipflop flipflops coaster coasters shirt shirts wallet wallets cover covers bedding beddings');
  var TYPE_LIST = Object.keys(TYPE);

  var files = {}; // letter -> parsed file | null
  var pending = {}; // letter -> { promise, controller }

  function toSet(s) {
    var o = {};
    s.split(' ').forEach(function (w) { o[w] = true; });
    return o;
  }

  // Same list as NOT_PLURAL in src/modules/store-search/search-bestsellers.ts.
  var NOT_PLURAL = toSet('christmas xmas canvas atlas texas bias gas yes this its kansas');
  function singular(w) {
    if (NOT_PLURAL[w]) return w;
    if (w.length > 4 && /ies$/.test(w)) return w.slice(0, -3) + 'y';
    if (/(sses|shes|ches|xes|zes)$/.test(w)) return w.slice(0, -2);
    if (w.length > 3 && /s$/.test(w) && !/(ss|us|is)$/.test(w)) return w.slice(0, -1);
    return w;
  }

  function tokens(text) {
    return String(text || '')
      .toLowerCase()
      .replace(/['’]/g, '')
      .split(/[^a-z0-9À-ɏ]+/)
      .filter(function (w) { return w && !/\d/.test(w); });
  }

  function isTypeWord(w) {
    return !!(STOP[w] || TYPE[w] || TYPE[singular(w)]);
  }

  function isTypePrefix(w) {
    for (var i = 0; i < TYPE_LIST.length; i++) if (TYPE_LIST[i].indexOf(w) === 0) return true;
    return false;
  }

  /* The word that carries the design: the last meaningful token. A trailing
     partial type word ("wolf sne") is skipped when something else is typed. */
  function parseQuery(text) {
    var all = tokens(text).filter(function (w) { return !isTypeWord(w); });
    var focus = null;
    var others = [];
    for (var i = all.length - 1; i >= 0; i--) {
      var w = all[i];
      if (!focus && i === all.length - 1 && all.length > 1 && isTypePrefix(w)) continue;
      if (!focus) focus = w;
      else others.push(w);
    }
    if (!focus || focus.length < 3) return null;
    return { focus: focus, others: others };
  }

  function letterOf(w) {
    var c = w.charAt(0);
    return c >= 'a' && c <= 'z' ? c : '0';
  }

  function load(letter) {
    if (Object.prototype.hasOwnProperty.call(files, letter)) return Promise.resolve(files[letter]);
    if (pending[letter]) return pending[letter].promise;
    // A different letter still loading is stale now: abort it.
    Object.keys(pending).forEach(function (l) {
      try { pending[l].controller.abort(); } catch (e) {}
      delete pending[l];
    });
    var url = urls[letter];
    if (!url) return Promise.resolve(null);
    var controller = window.AbortController ? new AbortController() : { abort: function () {}, signal: undefined };
    var promise = fetch(url, { credentials: 'omit', signal: controller.signal })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        var ok = data && data.keywords && data.products ? data : null;
        files[letter] = ok;
        return ok;
      })
      .catch(function () { return null; })
      .then(function (data) {
        if (pending[letter] && pending[letter].promise === promise) delete pending[letter];
        return data;
      });
    pending[letter] = { promise: promise, controller: controller };
    return promise;
  }

  function firstSuggestionWords(container) {
    var el = container.querySelector('#predictive-search-results-queries-list .predictive-search__item-query-result');
    if (!el) return [];
    return tokens(el.getAttribute('aria-label') || el.textContent).map(singular);
  }

  /* Candidates: keywords (and plural aliases) that start with the typed word,
     plus a word of Shopify's first suggestion when it is a keyword (covers
     spelling fixes). Highest total units wins, but a title-backed keyword
     always beats a tag-only one (g: 1), so "sun" stays "sun", not
     "sunandmoon". A tag-only keyword typed in full ("animal") counts as
     title-backed. Nothing found: typo fallback (closestKeyword). */
  function chooseKeyword(file, focus, suggestion) {
    var kw = file.keywords;
    var one = singular(focus);
    var seen = {};
    var best = null;
    function rank(k) { return kw[k].g && k !== focus && k !== one ? 0 : 1; }
    function consider(k) {
      if (!k || seen[k] || !kw[k]) return;
      seen[k] = true;
      if (!best || rank(k) > rank(best) || (rank(k) === rank(best) && kw[k].s > kw[best].s)) best = k;
    }
    consider(one);
    for (var k in kw) if (k.indexOf(focus) === 0) consider(k);
    var aliases = file.aliases || {};
    for (var a in aliases) if (a.indexOf(focus) === 0) consider(aliases[a]);
    var stem = focus.slice(0, 3);
    suggestion.forEach(function (w) { if (w.indexOf(stem) === 0) consider(w); });
    return best || closestKeyword(kw, focus);
  }

  /* Typo fallback ("halowen" -> "halloween"): only when nothing above matched
     and the word has 5+ letters. Searches this letter's file only (no extra
     fetch). Max distance 2 for 5-7 letters, 3 for 8+; more sales wins ties. */
  function closestKeyword(kw, focus) {
    if (focus.length < 5) return null;
    var max = focus.length >= 8 ? 3 : 2;
    var best = null;
    var bestD = max + 1;
    for (var k in kw) {
      if (Math.abs(k.length - focus.length) > max) continue;
      var d = editDistance(focus, k, max);
      if (d > max) continue;
      var better = !best || d < bestD ||
        (d === bestD && (!kw[k].g && kw[best].g || (!kw[k].g === !kw[best].g && kw[k].s > kw[best].s)));
      if (better) {
        best = k;
        bestD = d;
      }
    }
    return bestD <= max ? best : null;
  }

  /* Damerau-Levenshtein (optimal string alignment): adjacent swaps cost 1.
     Returns max + 1 as soon as every cell of a row is past max. */
  function editDistance(a, b, max) {
    var prev2 = null;
    var prev = [];
    for (var j = 0; j <= b.length; j++) prev[j] = j;
    for (var i = 1; i <= a.length; i++) {
      var cur = [i];
      var rowMin = i;
      for (var j2 = 1; j2 <= b.length; j2++) {
        var cost = a[i - 1] === b[j2 - 1] ? 0 : 1;
        var v = Math.min(prev[j2] + 1, cur[j2 - 1] + 1, prev[j2 - 1] + cost);
        if (prev2 && i > 1 && j2 > 1 && a[i - 1] === b[j2 - 2] && a[i - 2] === b[j2 - 1])
          v = Math.min(v, prev2[j2 - 2] + 1);
        cur[j2] = v;
        if (v < rowMin) rowMin = v;
      }
      if (rowMin > max) return max + 1;
      prev2 = prev;
      prev = cur;
    }
    return prev[b.length];
  }

  function tilesFor(file, keyword, others) {
    var entry = file.keywords[keyword];
    var ib = file.ib || '';
    var list = [];
    for (var i = 0; i < entry.p.length; i++) {
      var p = file.products[entry.p[i]];
      if (!p || !p.h) continue;
      var title = String(p.t || '').toLowerCase();
      var ok = others.every(function (o) { return title.indexOf(o) !== -1; });
      if (!ok) continue;
      var img = p.i || '';
      if (img && !/^(https?:)?\/\//.test(img)) img = ib + img;
      list.push({ h: p.h, t: p.t || '', i: img });
    }
    return list;
  }

  function el(tag, attrs, text) {
    var n = document.createElement(tag);
    for (var k in attrs) n.setAttribute(k, attrs[k]);
    if (text != null) n.textContent = text;
    return n;
  }

  /* The products list is always rendered by sections/predictive-search.liquid
     (possibly empty). Older markup without it: no swap, Shopify's tiles stay. */
  function productsList(container) {
    return container.querySelector('#predictive-search-results-products-list');
  }

  /* Same markup as the Liquid tiles in sections/predictive-search.liquid. */
  function render(container, keyword, tiles) {
    var ul = productsList(container);
    var count = Math.min(tiles.length, MAX_TILES);
    if (!ul || count === 0) return;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var frag = document.createDocumentFragment();
    for (var i = 0; i < count; i++) {
      var t = tiles[i];
      var li = el('li', { id: 'predictive-search-option-product-' + (i + 1), class: 'predictive-search__list-item ywv-ps__tile', role: 'option', 'aria-selected': 'false' });
      var a = el('a', { href: root + 'products/' + encodeURIComponent(t.h), class: 'predictive-search__item ywv-ps__tile-link link link--text', tabindex: '-1' });
      var media = el('span', { class: 'ywv-ps__tile-media' });
      if (t.i) media.appendChild(el('img', { src: t.i, alt: t.t, width: '300', height: '300' }));
      a.appendChild(media);
      a.appendChild(el('span', { class: 'ywv-ps__tile-title' }, t.t));
      li.appendChild(a);
      frag.appendChild(li);
    }
    while (ul.firstChild) ul.removeChild(ul.firstChild);
    ul.appendChild(frag);
    ul.setAttribute('data-ywv-best', keyword);
  }

  function attach(ps) {
    if (ps.__ywvBest) return;
    var container = ps.querySelector('[data-predictive-search]');
    var input = ps.querySelector('input[type="search"]');
    if (!container || !input) return;
    ps.__ywvBest = true;
    var generation = 0;

    function apply() {
      var gen = ++generation;
      var q = parseQuery(input.value);
      if (!q) return;
      if (!container.querySelector('#predictive-search-results')) return;
      load(letterOf(q.focus)).then(function (file) {
        try {
          if (gen !== generation || !file) return;
          var now = parseQuery(input.value);
          if (!now || now.focus !== q.focus) return;
          var keyword = chooseKeyword(file, q.focus, firstSuggestionWords(container));
          if (!keyword) return;
          var tiles = tilesFor(file, keyword, q.others);
          if (tiles.length) render(container, keyword, tiles);
        } catch (e) {}
      });
    }

    // Shopify replaces the dropdown's innerHTML on every render (fresh or cached).
    new MutationObserver(function () {
      try { apply(); } catch (e) {}
    }).observe(container, { childList: true });

    // Warm the letter file on the first keystroke so the swap is ready in time.
    input.addEventListener('input', function () {
      try {
        var q = parseQuery(input.value);
        if (q) load(letterOf(q.focus));
      } catch (e) {}
    });
  }

  function init() {
    try {
      var all = document.querySelectorAll('predictive-search');
      for (var i = 0; i < all.length; i++) attach(all[i]);
    } catch (e) {}
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
